import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'

import Isvg from 'react-inlinesvg'

import styles from './question_drag.scss'

import CollapseSvg from 'assets/components/question/collapse-arrow.svg'

class QuizQuestionDrag extends PureComponent {

	render() {
		return (
			<div styleName='wrapper'>
				<div styleName='collapse-btn'>
					<Isvg src={CollapseSvg} cacheGetRequests={true} styleName='collapse-btn-icon' />
				</div>
				<p styleName='text'>{this.props.title}</p>
			</div>
		)
	}

}

QuizQuestionDrag.propTypes = {
	title: PropTypes.string,
}

export default CSSModules(QuizQuestionDrag, styles, {allowMultiple: true})
